import { InternSet } from "internmap";
export default function difference(values) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        others[_i - 1] = arguments[_i];
    }
    values = new InternSet(values);
    for (var _a = 0, others_1 = others; _a < others_1.length; _a++) {
        var other = others_1[_a];
        for (var _b = 0, other_1 = other; _b < other_1.length; _b++) {
            var value = other_1[_b];
            values["delete"](value);
        }
    }
    return values;
}
